import { UseCase } from '@barkibu/noma-commons';
import { Assessment } from '../../domain/assessment/Assessment';
import { AssessmentRepository } from '../../domain/assessment/AssessmentRepository';

export class AddSymptomToAssessment implements UseCase<Assessment> {
    private assessmentRepository: AssessmentRepository;

    constructor(assessmentRepository: AssessmentRepository) {
        this.assessmentRepository = assessmentRepository;
    }

    async execute(assessmentKey: string, symptomKey: string): Promise<Assessment> {
        return this.assessmentRepository.addSymptom(assessmentKey, {
            symptomKey,
        });
    }
}
